import React from "react";
import "../../App.css";
import lhome from "./home-but.svg";

const CFHomePanel: React.FunctionComponent = () => {
  return <img className="lhomebut" src={lhome} alt="HomeBut" />;
};

export default CFHomePanel;
